const ring = 'prod';
export const environment = {
  production: true,
  envName: ring,

  //*************urls*************
  // Testing runs against the app-service hostname BEFORE the DNS cutover.
  //rootSite: 'https://har-hcs-corp-' + ring + '.azurewebsites.net',
  // AT DNS CUTOVER — paste this over the line above:
  rootSite: 'https://harrellscoatingssolutions.com',

  appAPIUrl: 'https://har-hcs-api-' + ring + '.azurewebsites.net/api',
  //harfilesAPIUrl: 'https://har-filemanager-' + ring + '.azurewebsites.net/api',
  // AT DNS CUTOVER (File Repository) — paste this over the line above:
  harfilesAPIUrl: 'https://documents.harrells.com/api',
};
